<div class="question-holder trans-y-hide slideFromBottom">
  @for (order of orders$ | async; track order) {
    <div class="question bg-fff" (click)="viewOrder(order, $event)">
      <div class="order">
        <div class="content">
          <img [src]="getOrderImage(order)" />
          <div class="desc">
            <div class="stage" [ngClass]='{ "active": !appConfig.Shared.Order.Stage.CompletedStages.includes(order.stage) }'>
              {{order.stage?.toLowerCase().split('_').join(' ')}}
            </div>
            <div class="bullet">
              <div class="dib" i18n="@@orderNo">Order no:</div>
              <div class="dib pL5">{{'#'+order.orderNumber}}</div>
            </div>
            <div class="bullet">₹{{order.amount}}/-</div>
          </div>
        </div>
        <div class="buttons">
          @if (appConfig.Shared.Order.Stage.AfterShipment.includes(order?.stage)) {
            <div class="btn" (click)="editOrder(order, $event)">
              Edit
            </div>
          }
          @if (appConfig.Shared.Order.Stage.AfterShipment.includes(order?.stage)) {
            <div class="btn" (click)="trackOrder(order, $event)">
              Track
            </div>
          }
          @if (appConfig.Shared.Order.Stage.BeforeShipment.includes(order?.stage) || appConfig.Shared.Order.Stage.CompletedStages.includes(order?.stage)) {
            <div class="btn w100" (click)="viewOrder(order, $event)">
              View
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
